import { render } from "./ServiceCardSkeleton.vue?vue&type=template&id=ed0e5b7a&scoped=true"
import script from "./ServiceCardSkeleton.vue?vue&type=script&lang=js"
export * from "./ServiceCardSkeleton.vue?vue&type=script&lang=js"

import "./ServiceCardSkeleton.vue?vue&type=style&index=0&id=ed0e5b7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed0e5b7a"]])

export default __exports__